/**
 * DTOs de entrada del catálogo de planes (`/modules/:code/plans`). Ver docs/FASE-0.md §5 "Planes".
 * La salida ya existe como `PlanSchema` en `../plans.js`.
 */
import { z } from "zod";
import { PATTERNS } from "../constants.js";
import { FeatureValueSchema } from "../entitlements.js";
import { BillingModelSchema, PlanStatusSchema } from "../plans.js";
export const CreatePlanInputSchema = z.object({
    code: z.string().regex(PATTERNS.KEY),
    name: z.string().min(1).max(120),
    description: z.string().max(400).nullable().optional(),
    priceMonthly: z.string().regex(/^\d+(\.\d{1,2})?$/),
    currency: z.string().length(3).default("PEN"),
    billingModel: BillingModelSchema,
    status: PlanStatusSchema.default("active"),
    sortOrder: z.number().int().default(0),
    /** featureKey → valor. */
    features: z.record(z.string().regex(PATTERNS.KEY), FeatureValueSchema).default({}),
    /** limitKey → máximo (`null` = ilimitado). */
    limits: z.record(z.string().regex(PATTERNS.KEY), z.number().nullable()).default({}),
});
export const UpdatePlanInputSchema = CreatePlanInputSchema.partial().omit({ code: true });
//# sourceMappingURL=plans.js.map